module.exports = __webpack_public_path__ + "img/szzc.bca5d560.png";